import { connect } from 'react-redux';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import Slider from '../components/Slider';
import { Source } from '../components/Source';
import { ParentStarSVG } from '../components/ParentStarSVG';

import '../global-sass/main.scss';

export class WidgetContainer extends React.Component {
	render() {
		return (
			<Common
				render={({ prefs, labels }) => {
					const {
						sources,
						reviewTruncationLength,
						arrowStyle,
						fontSize,
						reviewDateFontSize,
						nextSlideControlPosition,
						previousSlideControlPosition,
						ratingStarFullFillColor
					} = prefs;

					const sourcesArray = sources.split(',');
					const singleSource = sourcesArray.length === 1;

					return (
						<React.Fragment>
							<ParentStarSVG />
							{singleSource && (
								<Source
									source={sources}
									singleSource={singleSource}
								/>
							)}
							<Slider
								singleSource={singleSource}
								arrowStyle={arrowStyle}
								reviewTruncationLength={parseInt(
									reviewTruncationLength,
									10
								)}
								labels={labels}
								fontSize={`ddc-font-size-${fontSize}`}
								reviewDateFontSize={`ddc-font-size-${reviewDateFontSize}`}
								nextSlideControlPosition={
									nextSlideControlPosition
								}
								previousSlideControlPosition={
									previousSlideControlPosition
								}
								ratingStarFullFillColor={
									ratingStarFullFillColor
								}
							/>
						</React.Fragment>
					);
				}}
			/>
		);
	}
}

WidgetContainer.propTypes = {};

const mapStateToProps = (_state) => {
	return {};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
